export enum AnalyticsEvents {
  ConnectVisit = 'Connect Visit',
  ConnectSignUp = 'Connect Sign Up',
  SignUpFail = 'Sign Up Fail',
  Login = 'Login',
  LoginSSO = 'Login SSO',
  LoginFail = 'Login Fail',
  Logout = 'Logout',
  LocationSelected = 'Location Selected',
  CategorySelected = 'Category Selected',
  ServiceSelected = 'Service Selected',
  ClassSelected = 'Class Selected',
  DateSelected = 'Date Selected',
  AppointmentSelected = 'Appointment Selected',
  BookingMade = 'Booking Made',
  AppointmentTimeBackButton = 'Appointment Time Back Button',
  ChangeDate = 'AppointmentSelectScreenChangeDate',
  Previous = 'AppointmentSelectScreenPrevious',
  Next = 'AppointmentSelectScreenNext',
  NextAvailable = 'AppointmentSelectNextAvailable',
  AppointmentBooked = 'AppointmentBooked',
  DisconnectSSO = 'Disconnect SSO'
}
// future proofing for if we add our own analytics events
export const analyticsEventMapping: Record<AnalyticsEvents, { ga: string; analytics: string }> = {
  [AnalyticsEvents.ConnectVisit]: { ga: '', analytics: 'Connect Visit' },
  [AnalyticsEvents.ConnectSignUp]: { ga: 'sign_up', analytics: 'Connect Sign Up' },
  [AnalyticsEvents.SignUpFail]: { ga: 'sign_up_failed', analytics: 'Sign Up Fail' },
  [AnalyticsEvents.Login]: { ga: 'login', analytics: 'Login' },
  [AnalyticsEvents.LoginSSO]: { ga: 'login_sso', june: 'Login SSO' },
  [AnalyticsEvents.DisconnectSSO]: { ga: 'disconnect_sso', june: 'Disconnect SSO' },
  [AnalyticsEvents.LocationSelected]: { ga: 'location_selected', analytics: 'Location Selected' },
  [AnalyticsEvents.CategorySelected]: { ga: 'category_selected', analytics: 'Category Selected' },
  [AnalyticsEvents.ServiceSelected]: { ga: 'service_selected', analytics: 'Service Selected' },
  [AnalyticsEvents.ClassSelected]: { ga: 'class_selected', analytics: 'Class Selected' },
  [AnalyticsEvents.DateSelected]: { ga: 'date_selected', analytics: 'Date Selected' },
  [AnalyticsEvents.AppointmentSelected]: {
    ga: 'appointment_selected',
    analytics: 'Appointment Selected'
  },
  [AnalyticsEvents.BookingMade]: { ga: '', analytics: 'Booking Made' },
  [AnalyticsEvents.AppointmentTimeBackButton]: { ga: 'Appointment_Time_BackButton', analytics: '' },
  [AnalyticsEvents.ChangeDate]: { ga: 'AppointmentSelectScreenChangeDate', analytics: '' },
  [AnalyticsEvents.Previous]: { ga: 'AppointmentSelectScreenPrevious', analytics: '' },
  [AnalyticsEvents.Next]: { ga: 'AppointmentSelectScreenNext', analytics: '' },
  [AnalyticsEvents.NextAvailable]: { ga: 'AppointmentSelectNextAvailable', analytics: '' },
  [AnalyticsEvents.AppointmentBooked]: { ga: '', analytics: 'Appointment Booked' }
};
